<button
  (click)="toggleTheme()"
  class="relative w-20 h-10 px-1 py-1 flex items-center justify-between rounded-full focus:outline-none focus:shadow-outline bg-white dark:bg-gray-700 transition-colors"
  role="menuitem"
>
  <div
    [@slideToggle]="isDarkTheme ? 'dark' : 'light'"
    class="absolute left-0 top-0 w-1/2 h-full flex items-center justify-center"
    style="padding: 8px; box-sizing: border-box"
  >
    @if (!isDarkTheme) {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6 text-yellow-500"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
        />
      </svg>
    }
    @if (isDarkTheme) {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6 text-gray-700 dark:text-gray-400"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
        />
      </svg>
    }
  </div>
  <div
    class="flex-grow text-sm text-gray-600 dark:text-white mx-auto"
    [ngClass]="{ 'ml-4': !isDarkTheme, 'mr-5': isDarkTheme }"
  >
    {{ isDarkTheme ? "Dark" : "Light" }}
  </div>
</button>
